import { Controller } from "@hotwired/stimulus"

// Toggles project favorite (star) via AJAX.
//
// Usage:
//   <span data-controller="favorite"
//         data-favorite-project-id-value="123"
//         data-favorite-add-url-value="/en/users/add_to_user_favorite_projects"
//         data-favorite-remove-url-value="/en/users/remove_from_user_favorite_projects"
//         data-favorite-active-value="true"
//         data-action="click->favorite#toggle mouseenter->favorite#hoverIn mouseleave->favorite#hoverOut">
//     <svg data-favorite-target="icon" ...></svg>
//   </span>

const COLOR_ACTIVE = "#f59e0b"
const COLOR_INACTIVE = "#9b9b9b"

export default class extends Controller {
  static targets = ["icon"]
  static values = {
    projectId: Number,
    addUrl: String,
    removeUrl: String,
    active: { type: Boolean, default: false }
  }

  connect() {
    this.hovering = false
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.activeValue = !this.activeValue
    this.render()

    const url = this.activeValue ? this.addUrlValue : this.removeUrlValue
    const method = this.activeValue ? "POST" : "DELETE"

    const formData = new FormData()
    formData.append("project_id", this.projectIdValue)

    fetch(url, {
      method: method,
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
      .then(resp => { if (!resp.ok) throw new Error("Failed") })
      .catch(() => {
        this.activeValue = !this.activeValue
        this.render()
      })
  }

  hoverIn(event) {
    this.hovering = true
    this.render()
  }

  hoverOut(event) {
    this.hovering = false
    this.render()
  }

  render() {
    const svg = this.iconTarget
    if (this.activeValue || this.hovering) {
      svg.setAttribute("fill", this.activeValue ? COLOR_ACTIVE : "none")
      svg.setAttribute("stroke", COLOR_ACTIVE)
    } else {
      svg.setAttribute("fill", "none")
      svg.setAttribute("stroke", COLOR_INACTIVE)
    }
  }
}
